import { Grid, Rating, Typography } from '@mui/material'

import type { RatingProps } from '@mui/material'
import type { FC } from 'react'

interface BusinessRatingProps extends Pick<RatingProps, 'size' | 'sx'> {
	rating?: number
	totalRatings?: number
}

export const BusinessRating: FC<BusinessRatingProps> = ({
	rating,
	totalRatings,
	size = 'medium',
	...rest
}) => {
	return (
		<Grid container direction="row" gap={0.5} alignItems="start" justifyContent="flex-start">
			<Typography variant="body2" color="text.secondary">
				{rating ?? 0}
			</Typography>
			<Rating {...rest} size={size} name="read-only" value={rating} readOnly />
			{totalRatings !== undefined && (
				<Typography data-testid="total-rating" variant="body2" color="text.secondary">
					({totalRatings})
				</Typography>
			)}
		</Grid>
	)
}
